export const mainOptions = [
  {
    id: 1,
    label: "Dashboard",
    url: "/dashboard",
    inactiveIcon: require("../../assets/svgs/dashboard-white.svg").default,
    activeIcon: require("../../assets/svgs/dashboard-white.svg").default,
  },
  {
    id: 2,
    label: "Products",
    url: "/products",
    inactiveIcon: require("../../assets/svgs/products-white.svg").default,
    activeIcon: require("../../assets/svgs/products-white.svg").default,
  },
  {
    id: 3,
    label: "My Balance",
    url: "/my-balance",
    inactiveIcon: require("../../assets/svgs/payments-white.svg").default,
    activeIcon: require("../../assets/svgs/payments-white.svg").default,
  },
];

export const otherOptions = [
  {
    id: 4,
    isLinkGroup: true,
    label: "Bags",
    icon: require("../../assets/svgs/sendbag-white.svg").default,
    sublinks: [
      {
        id: 1,
        label: "Request Bags",
        url: "/request-a-bag",
        inactiveIcon: require("../../assets/svgs/box.svg").default,
        activeIcon: require("../../assets/svgs/box.svg").default,
      },
      {
        id: 2,
        label: "Send Bags",
        url: "/send-a-bag",
        inactiveIcon: require("../../assets/svgs/truck.svg").default,
        activeIcon: require("../../assets/svgs/truck.svg").default,
      },
    ],
  },
  // {
  //   id: 5,
  //   label: "Requests",
  //   url: "/requests",
  //   inactiveIcon: require("../../assets/svgs/request-white.svg").default,
  //   activeIcon: require("../../assets/svgs/request-white.svg").default,
  // },
  {
    id: 5,
    label: "Drop-off Location",
    url: "/drop-off-locations",
    inactiveIcon: require("../../assets/svgs/shopping-cart.svg").default,
    activeIcon: require("../../assets/svgs/shopping-cart.svg").default,
  },
  {
    id: 6,
    label: "Items To Be Returned",
    url: "/items-to-be-returned",
    inactiveIcon: require("../../assets/svgs/shopping-cart.svg").default,
    activeIcon: require("../../assets/svgs/shopping-cart.svg").default,
  },
  {
    id: 7,
    label: "Item Donated to Charity",
    url: "/items-donated-to-charity",
    inactiveIcon: require("../../assets/svgs/heart-hand.svg").default,
    activeIcon: require("../../assets/svgs/heart-hand.svg").default,
  },
];

export const accountOptions = [
  {
    id: 8,
    label: "Terms and Conditions",
    url: "/terms-and-conditions",
    inactiveIcon: require("../../assets/svgs/terms-white.svg").default,
    activeIcon: require("../../assets/svgs/terms-white.svg").default,
  },
  {
    id: 9,
    label: "FAQS",
    url: "/faqs",
    inactiveIcon: require("../../assets/svgs/faqs-white.svg").default,
    activeIcon: require("../../assets/svgs/faqs-white.svg").default,
  },
];
